import React, { FC, useState } from "react";
import { StandardContextProps } from "@/types/contextTypes";
import { DarkModeContext } from "@/contexts/DarkModeContext/DarkModeContext";

export const DarkModeContextProvider: FC<StandardContextProps> = ({
  children,
}) => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);

  return (
    <DarkModeContext.Provider value={{ isDarkMode, setIsDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
};
